import { render, staticRenderFns } from "./CreateBook.vue?vue&type=template&id=8245b54a&"
import script from "./CreateBook.vue?vue&type=script&lang=js&"
export * from "./CreateBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports